import { InMemoryCache } from 'apollo-cache-inmemory/lib/inMemoryCache'
import gql from 'graphql-tag'
import get from 'lodash-es/get'

export const submissionDefaults = {
  Submission: {
    __typename: 'Submission',
    expanded: false,
    visibleForm: null,
    comments: '',
    feedback: ''
  }
}

export const submissionResolvers = {
  Submission: {
    expanded: (obj, args, { cache }) => {
      const submission = cache.readFragment({
        fragment: gql`
          fragment expanded on Submission { expanded }
        `,
        id: `Submission:${obj.id}`
      })
      return get(submission, 'expanded', false)
    },
    visibleForm: (obj, args, { cache }) => {
      const submission = cache.readFragment({
        fragment: gql`
          fragment visibleForm on Submission { visibleForm }
        `,
        id: `Submission:${obj.id}`
      })
      return submission && submission.visibleForm
    }
  },
}

export const submissionMutations = {
  UpdateSubmissionUi: (_, args: { id: number, updates: any }, ctx: { cache: InMemoryCache }) => {
    ctx.cache.writeData({ id: `Submission:${args.id}`, data: args.updates })
    return null // When resolvers can be defined per feature, return cache.readFragment feature specific fragment
  },
}
